import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/app/model/store';

const selectAuthSlice = (state: RootState) => state.auth;

export const selectIsReportLimitedSession = createSelector(
  [selectAuthSlice],
  (auth) => auth.isReportLimitedSession,
);

export const selectLimitedReportId = createSelector(
  [selectAuthSlice],
  (auth) => auth.limitedReportId,
);

export const selectIsPresignSession = createSelector(
  [selectAuthSlice],
  (auth) => auth.isPresignSession,
);

export const selectPendingMFARequirement = createSelector(
  [selectAuthSlice],
  (auth) => auth.pendingMFARequirement,
);

export const selectMFAStatus = createSelector(
  [selectAuthSlice],
  (auth) => auth.mfaStatus,
);

export const selectMFAStatusLoading = createSelector(
  [selectAuthSlice],
  (auth) => auth.mfaStatusLoading,
);

export const selectIsMFAEnabled = createSelector(
  [selectMFAStatus],
  (status) => status?.Enabled ?? false,
);

export const selectHasActiveMFARecoveryCodes = createSelector(
  [selectAuthSlice],
  (auth) => auth.activeMFARecoveryCodeRequests.length > 0,
);
